import React from "react";
import {GatsbyImage} from "gatsby-plugin-image";

const SimpleHero = (
  {
    imageData= null,
    contentData = null,
  }
) => {
  return (
    <section className="simple-hero">
      <div className="simple-hero__media-container">
        <GatsbyImage
          className="simple-hero__image"
          image={imageData}
          alt={contentData.title}
        />
      </div>
      <div className="simple-hero__content-container">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="simple-hero__pre-title">{contentData.pre_title}</div>
              <h1 className="simple-hero__title">{contentData.title}</h1>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SimpleHero
